import {
  Flex,
  Text,
  Button,
  Tooltip,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import { useEffect, useState, useRef, useCallback } from "react";

import { toast } from "react-toastify";

import html2canvas from "html2canvas";

import {
  FaListUl,
  FaUsers,
  FaStar,
  FaComments,
  FaCalendar,
} from "react-icons/fa";

import axios from "axios";
import apiUrl from "variables/api";

import ManageModal from "./components/ManageModal";
import ScheduleModal from "./components/ScheduleModal"; // Importuj modal
import UsersModal from "./components/UsersModal"; // Importuj modal

export default function Semestr() {
  const {
    isOpen: isManageOpen,
    onOpen: onManageOpen,
    onClose: onManageClose,
  } = useDisclosure();
  const {
    isOpen: isScheduleOpen,
    onOpen: onScheduleOpen,
    onClose: onScheduleClose,
  } = useDisclosure();
  const {
    isOpen: isUsersOpen,
    onOpen: onUsersOpen,
    onClose: onUsersClose,
  } = useDisclosure();
  const [scheduleData, setScheduleData] = useState({ trainings: [] });
  const [companyData, setCompanyData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [actualCompany, setActualCompany] = useState(null);
  const [peoples, setPeoples] = useState([]);
  const [loading, setLoading] = useState(true);

  const tableRef = useRef(null);
  

  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const fetchCompanyData = () => {
    axios
      .get(apiUrl + "/data/school/company/list", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        setCompanyData(response.data);
        setActualCompany(response.data.find((company) => company.active === 1));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchUsersData = () => {
    axios
      .get(apiUrl + "/data/school/company/users/list", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        setUsersData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchScheduleData = () => {
    axios
      .get(apiUrl + "/data/school/company/schedule", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        setScheduleData({
          trainings: JSON.parse(response.data[0].trainings),
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchCompanyData();
    fetchUsersData();
    fetchScheduleData();
  }, []);

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px" gap="3">
        <Flex gap="5">
          <Text fontSize="xl" fontWeight="bold">
            Zarządzanie kompaniami
          </Text>

          {(localStorage.getItem("roles").includes("973337145844584538") ||
            localStorage.getItem("roles").includes("973342432446009344") ||
            localStorage.getItem("roles").includes("973342432659914823") ||
            localStorage.getItem("roles").includes("1190995987154616381")) && (
            <Flex gap="3">
              <Tooltip label="Zarządzanie kompaniami" hasArrow placement="top">
                <Button colorScheme="orange" size="sm" onClick={onManageOpen}>
                  <FaListUl />
                </Button>
              </Tooltip>
              <Tooltip label="Edytuj harmonogram" hasArrow placement="top">
                <Button
                  colorScheme="purple"
                  size="sm"
                  onClick={onScheduleOpen}
                  disabled={!actualCompany}
                >
                  <FaCalendar />
                </Button>
              </Tooltip>
              <Tooltip
                label="Zarządzanie użytkownikami"
                hasArrow
                placement="top"
              >
                <Button
                  colorScheme="blue"
                  size="sm"
                  onClick={onUsersOpen}
                  disabled={!actualCompany}
                >
                  <FaUsers />
                </Button>
              </Tooltip>
            </Flex>
          )}
        </Flex>
        <Flex gap="12">
          <Flex direction="column">
            {actualCompany ? (
              <>
                <Text fontSize="md">
                  Obecna kompania: KS{actualCompany?.id}/
                  {actualCompany?.startDate.split("-")[0]}
                </Text>
                <Text fontSize="md">
                  Data rozpoczęcia: {actualCompany?.startDate?.split("T")[0]}
                </Text>
                <Text fontSize="md">
                  Liczba akademików: {actualCompany.liczba_akademikow}
                </Text>
              </>
            ) : (
              <Text fontSize="md">Brak aktualnej kompanii</Text>
            )}
          </Flex>
          <Flex direction="column">
            <TableContainer>
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Pluton 1</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {usersData
                    ?.filter((user) => user.platoon === 1)
                    ?.map((user) => (
                      <Tr key={user.id}>
                        <Td>
                          <Text as={user.archived ? "s" : undefined}>
                            {peoples.find(
                              (peoples) => peoples.value === user.userID
                            )?.label || "Nie znaleziono"}
                          </Text>
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
          <Flex direction="column">
            <TableContainer>
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Pluton 2</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {usersData
                    ?.filter((user) => user.platoon === 2)
                    ?.map((user) => (
                      <Tr key={user.id}>
                        <Td>
                          <Text as={user.archived ? "s" : undefined}>
                            {peoples.find(
                              (peoples) => peoples.value === user.userID
                            )?.label || "Nie znaleziono"}
                          </Text>
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
          <Flex direction="column">
            <TableContainer>
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Pluton 3</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {usersData
                    ?.filter((user) => user.platoon === 3)
                    ?.map((user) => (
                      <Tr key={user.id}>
                        <Td>
                          <Text as={user.archived ? "s" : undefined}>
                            {peoples.find(
                              (peoples) => peoples.value === user.userID
                            )?.label || "Nie znaleziono"}
                          </Text>
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
          <Flex direction="column">
            <TableContainer ref={tableRef} style={{ paddingBottom: "10px" }}>
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Nazwa</Th>
                    <Th>Data</Th>
                    <Th>Pluton I</Th>
                    <Th>Pluton II</Th>
                    <Th>Pluton III</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {scheduleData.trainings?.length >= 1 &&
                    scheduleData.trainings?.map((event, index) => (
                      <Tr key={index}>
                        <Td>{event.name}</Td>
                        <Td>{event.date}</Td>
                        <Td>{event.platoon1}</Td>
                        <Td>{event.platoon2}</Td>
                        <Td>{event.platoon3}</Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
        </Flex>
      </Card>
      <ManageModal
        isOpen={isManageOpen}
        onClose={onManageClose}
        companyData={companyData}
        actualCompany={actualCompany}
        fetchCompanyData={fetchCompanyData}
      /> 
      <ScheduleModal
        isOpen={isScheduleOpen}
        onClose={onScheduleClose}
        scheduleData={scheduleData}
        setScheduleData={setScheduleData}
        actualCompany={actualCompany}
        tableRef={tableRef}
      />
      <UsersModal
        isOpen={isUsersOpen}
        onClose={onUsersClose}
        onOpen={onUsersOpen}
        usersData={usersData}
        fetchUsersData={fetchUsersData}
        actualCompany={actualCompany}
        peoples={peoples}
      />
    </Flex>
  );
}
